export default __webpack_public_path__ + "static/media/experience_logo_mega_menu.d7c35909.svg";